/**
 * MCP Prompts Registration
 *
 * Prompts provide templates for common development tasks.
 */

import { McpServer } from '@modelcontextprotocol/sdk/server/mcp.js';
import { registerBuildFormPrompt } from './buildForm.js';
import { registerLayoutPagePrompt } from './layoutPage.js';
import { registerComponentUsagePrompt } from './componentUsage.js';

/**
 * Register all prompts with the MCP server
 */
export function registerPrompts(server: McpServer): void {
  registerBuildFormPrompt(server);
  registerLayoutPagePrompt(server);
  registerComponentUsagePrompt(server);
}
